import { useEffect } from 'react';

/*
 * Custom hook to handle the beforeunload event.
 * @param {function} cb - Callback function to be executed before the page is unloaded.
 *
 * @example
 * useLeavePage(() => {
 *   console.log('Page is about to be unloaded');
 * });
 */

const useLeavePage = (cb) => {
  useEffect(() => {
    const handleUnload = (event) => {
      cb();
    };

    window.addEventListener('unload', handleUnload);
    window.addEventListener('pagehide', handleUnload);

    return () => {
      window.removeEventListener('unload', handleUnload);
      window.removeEventListener('pagehide', handleUnload);
    };
  }, []);
};

export default useLeavePage;
